
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    popInfo: {
      type: Object,
      default: () => ({
        title: "test",
        detail: "test description",
      }),
    },
    reportDataMap: {
      type: Object,
      default: () => ({}),
    },
    cardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["doClose"],
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const reportData = {
      page_name: props.reportDataMap?.page_name,
      sku_name: props.reportDataMap?.sku_name || "",
      card_name: props.reportDataMap?.cardName || "",
      sku_unid: props.reportDataMap?.sku_unid + "" || "",
      task_card_type: props.cardInfo?.cardType === 1 ? '无星' : '3星',
    };
    // console.log({...reportData},'reportData')
    onMounted(() => {});
    onUnmounted(() => {
      emit("doClose");
    });
    const close = (type) => {
      // 点击继续学习
      $xesLog.track("button_click", {
        ...reportData,
        button_name: "pop_up_video_finish_button",
        pop_up_button_status: type,
      });
      emit("doClose");
    };
    // 弹框曝光
    $xesLog.track("pop_up_element_show", {
      ...reportData,
      pop_up_name: "video_finish_pop_up",
    });
    return {
      close,
    };
  },
};
